import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
//import Phuluchangkhongtable from "components/Tonghopvantai/Phuluchangkhongtable.js";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";
const Phulucduongsattable = React.memo(function Phulucduongsattable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [data, setData] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcpl11qd34?thangnam=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setData(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>STT</th>
          <th className={classes.tablebc_th} style={{ width: "15vw" }}>
            Loại hình
          </th>
          <th className={classes.tablebc_th}>Khối lượng vận chuyển</th>
          <th className={classes.tablebc_th}>So với cùng kỳ tăng, giảm (%)</th>
          <th className={classes.tablebc_th}>Khối lượng luân chuyển</th>
          <th className={classes.tablebc_th}>So với cùng kỳ tăng, giảm (%)</th>
          <th className={classes.tablebc_th}>
            Lũy kế KLVC từ đầu năm đến tháng báo cáo
          </th>
          <th className={classes.tablebc_th}>
            Lũy kế KLLC từ đầu năm đến tháng báo cáo
          </th>
          <th className={classes.tablebc_th}>Ghi chú</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tablesotan_td}>{row["stt"]}</td>
              <td className={classes.tablesotan_td}>{row["loaihinh"]}</td>
              <td className={classes.tablesotan_td}>{row["vanchuyen"]}</td>
              <td className={classes.tablesotan_td}>
                {Number(row["cungky_vanchuyen"]) > 0 &&
                Number(row["vanchuyen"]) > 0
                  ? row["vanchuyen"] !== row["cungky_vanchuyen"]
                    ? ((row["vanchuyen"] - row["cungky_vanchuyen"]) /
                        row["cungky_vanchuyen"]) *
                      100
                    : 0
                  : 0}
              </td>
              <td className={classes.tablesotan_td}>{row["luanchuyen"]}</td>
              <td className={classes.tablesotan_td}>
                {Number(row["cungky_luanchuyen"]) > 0 &&
                Number(row["luanchuyen"]) > 0
                  ? row["luanchuyen"] !== row["cungky_luanchuyen"]
                    ? ((row["luanchuyen"] - row["cungky_luanchuyen"]) /
                        row["cungky_luanchuyen"]) *
                      100
                    : 0
                  : 0}
              </td>
              <td className={classes.tablesotan_td}>
                {row["luyke_vanchuyen"]}
              </td>
              <td className={classes.tablesotan_td}>
                {row["luyke_luanchuyen"]}
              </td>
              <td className={classes.tablesotan_td}></td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table id="phulucduongsat" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Phulucduongsattable.propTypes = {
  thangnam: PropTypes.object,
};
export default Phulucduongsattable;
